import { profileman, profilemadame } from '../../img/profile';
import { createContext, useContext } from "react";
import { ContextSession } from '../../services/ContextSession';
import './fichadni.component.css';

export default function FichaActaMatrimonio({ dniData }) {
    const { sessionData } = useContext(ContextSession);
    const { nombre, apellido, username } = sessionData;

    function formatData(fechadenacimiento) {
        if (fechadenacimiento) {
            return fechadenacimiento.substring(0, 10);
        } else {
            return 'Fecha no disponible';
        }
    }

    function isDataEmpty(acta) {
        return (
            acta.numerotomo === "0" &&
            acta.numerofolio === "0" &&
            acta.nombresvaron === null &&
            acta.primerapellidovaron === null &&
            acta.segundoapellidovaron === null &&
            acta.tipoidentidadvaron === null &&
            acta.numeroidentidadvaron === null &&
            acta.nombresmujer === null &&
            acta.primerapellidomujer === null &&
            acta.segundoapellidomujer === null &&
            acta.tipoidentidadmujer === null &&
            acta.numeroidentidadmujer === null
        );
    }

    // Verificar si dniData es un array
    if (!Array.isArray(dniData)) {
        return (
            <div className="ficha">
                <div className="datos-container">
                    <div className="datos">
                        <div className="seccion">
                            <h2>Actas De Matrimonio</h2>
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="valor1" align='center'>No se encontraron datos para esta persona</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {dniData.length === 0 || dniData.every(isDataEmpty) ? (
                <div className="ficha">
                    <div className="datos-container">
                        <div className="datos">
                            <div className="seccion">
                                <h2>Actas De Matrimonio</h2>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="valor1" align='center'>No se encontró actas de matrimonio para esta persona</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                dniData.map((acta, index) => (
                    <div key={index} className="ficha">
                        <div className="datos-container">
                            <div className="datos">
                                <div className="seccion">
                                    <h2>Datos Acta De Matrimonio</h2>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="etiqueta1">Número De Tomo:</td>
                                                <td className="valor1">{acta.numerotomo}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Número De Folio:</td>
                                                <td className="valor">{acta.numerofolio}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Nombre Varón:</td>
                                                <td className="valor1">
                                                    {acta.nombresvaron
                                                        ? `${acta.nombresvaron} ${acta.primerapellidovaron} ${acta.segundoapellidovaron}`
                                                        : 'Dato no disponible'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Identidad Varón:</td>
                                                <td className="valor">{acta.numeroidentidadvaron}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Nombre Mujer:</td>
                                                <td className="valor1">
                                                    {acta.nombresmujer
                                                        ? `${acta.nombresmujer} ${acta.primerapellidomujer} ${acta.segundoapellidomujer}`
                                                        : 'Dato no disponible'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Identidad Mujer:</td>
                                                <td className="valor">{acta.numeroidentidadmujer}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Fecha De Matrimonio:</td>
                                                <td className="valor1">{formatData(acta.fechadematrimonio)}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">País Matrimonio:</td>
                                                <td className="valor">{acta.paismatrimonio}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Departamento Matrimonio:</td>
                                                <td className="valor1">{acta.departamentomatrimonio}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta">Municipalidad Matrimonio:</td>
                                                <td className="valor">{acta.munimatrimonio}</td>
                                            </tr>
                                            <tr>
                                                <td className="etiqueta1">Notas Marginales:</td>
                                                <td className="valor1">{acta.notasmarginales}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            )}
        </>
    );
}
